import { FC, ReactElement } from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * Skeleton placeholder for VideoSubject: thumbnail + metadata
 */
const VideoSubjectSkeleton: FC = (): ReactElement => (
  <Box>
    <Skeleton
      variant="rectangular"
      sx={{ width: '100%', height: 0, paddingTop: '75%' }}
    />
    <Box display="flex" alignItems="flex-start" sx={{ pt: 1, minWidth: 0 }}>
      <Skeleton variant="circular" width={32} height={32} />
      <Box sx={{ pl: 1, flex: 1, minWidth: 0 }}>
        <Skeleton width="80%" height={20} />
        <Skeleton width="60%" height={16} sx={{ mt: 0.3 }} />
      </Box>
    </Box>
  </Box>
);

export default VideoSubjectSkeleton;